import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, isRef as _isRef, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23f604a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "onLoad"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "none",
  version: "1.1",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("g", { style: {"opacity":"0.5"} }, [
        /*#__PURE__*/_createElementVNode("ellipse", {
          cx: "20",
          cy: "20",
          rx: "19.5",
          ry: "19.5",
          "fill-opacity": "0",
          "stroke-opacity": "0.5",
          stroke: "#FFFFFF",
          fill: "none",
          "stroke-width": "1"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("g", null, [
          /*#__PURE__*/_createElementVNode("g")
        ]),
        /*#__PURE__*/_createElementVNode("g", null, [
          /*#__PURE__*/_createElementVNode("g", null, [
            /*#__PURE__*/_createElementVNode("path", {
              d: "M28.31855354127884,19.082909967803957C28.167853541278838,18.819179967803954,25.19125354127884,12.979259967803955,19.42673354127884,12.979259967803955C13.66217354127884,12.979259967803955,10.685706541278838,18.819179967803954,10.534998541278839,19.082909967803957C10.308938441278839,19.497359967803956,10.308938441278839,20.024839967803956,10.534998541278839,20.439279967803955C10.685706541278838,20.703029967803957,13.66218354127884,26.542959967803956,19.42673354127884,26.542959967803956C25.19125354127884,26.542959967803956,28.167753541278838,20.703029967803957,28.31845354127884,20.439279967803955C28.50685354127884,20.024839967803956,28.50685354127884,19.497359967803956,28.31845354127884,19.082909967803957C28.31845354127884,19.082909967803957,28.31855354127884,19.082909967803957,28.31855354127884,19.082909967803957ZM19.42673354127884,25.035859967803955C14.528753541278839,25.035859967803955,11.891363541278839,19.761109967803954,11.891363541278839,19.761109967803954C11.891363541278839,19.761109967803954,14.528753541278839,14.486339967803955,19.42673354127884,14.486339967803955C24.324753541278838,14.486339967803955,26.962153541278838,19.761109967803954,26.962153541278838,19.761109967803954C26.962153541278838,19.761109967803954,24.324753541278838,25.035859967803955,19.42673354127884,25.035859967803955C19.42673354127884,25.035859967803955,19.42673354127884,25.035859967803955,19.42673354127884,25.035859967803955Z",
              fill: "#FFFFFF",
              "fill-opacity": "1"
            })
          ]),
          /*#__PURE__*/_createElementVNode("g", null, [
            /*#__PURE__*/_createElementVNode("path", {
              d: "M19.426823199481966,16.74692964553833C17.768983199481966,16.74692964553833,16.412603199481964,18.10327964553833,16.412603199481964,19.76108964553833C16.412603199481964,21.41886964553833,17.768983199481966,22.77524964553833,19.426823199481966,22.77524964553833C21.084543199481963,22.77524964553833,22.440923199481965,21.41886964553833,22.440923199481965,19.76108964553833C22.440923199481965,18.10327964553833,21.084543199481963,16.74692964553833,19.426823199481966,16.74692964553833C19.426823199481966,16.74692964553833,19.426823199481966,16.74692964553833,19.426823199481966,16.74692964553833ZM19.426823199481966,21.26813964553833C18.597903199481962,21.26813964553833,17.919683199481963,20.589979645538328,17.919683199481963,19.76108964553833C17.919683199481963,18.93219964553833,18.597903199481962,18.25400964553833,19.426823199481966,18.25400964553833C20.255683199481965,18.25400964553833,20.933843199481963,18.93219964553833,20.933843199481963,19.76108964553833C20.933843199481963,20.589979645538328,20.255683199481965,21.26813964553833,19.426823199481966,21.26813964553833C19.426823199481966,21.26813964553833,19.426823199481966,21.26813964553833,19.426823199481966,21.26813964553833Z",
              fill: "#FFFFFF",
              "fill-opacity": "1"
            })
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_4 = [
  _hoisted_3
]

import {ref, shallowRef, computed, watch, watchPostEffect} from 'vue'
import {useRouter} from 'vue-router'

/*
  宽度固定，图片等比例缩放；使用JS获取每张图片宽度和高度，结合 `relative` 和 `absolute` 定位
  计算每个图片的位置 `top`，`left`，保证每张新的图片都追加在当前高度最小的那列末尾
*/
interface Image {
  src: string // 图片地址
  title?: string // 图片名称
}

interface Props {
  images: Image[] // 图片数组
  columnCount?: number // 要划分的列数
  columnGap?: number // 各列之间的间隙，单位px
  width?: string | number // 瀑布流区域的总宽度
  borderRadius?: number // 瀑布流区域和图片圆角，单位px
  backgroundColor?: string // 瀑布流区域背景填充色
}


export default /*#__PURE__*/_defineComponent({
  props: {
    images: { type: Array, required: true, default: () => [] },
    columnCount: { type: Number, required: false, default: 3 },
    columnGap: { type: Number, required: false, default: 20 },
    width: { type: [String, Number], required: false, default: '100%' },
    borderRadius: { type: Number, required: false, default: 20 },
    backgroundColor: { type: String, required: false, default: '#fafafa' }
  },
  setup(__props: any) {

const props = __props as { images: Image[], columnCount: number, columnGap: number, width: string | number, borderRadius: number, backgroundColor: string }

const imagesProperty = ref<any[]>([])
const preColumnHeight = ref<number[]>(Array(props.columnCount).fill(0)) // 每列的高度
const waterfall = shallowRef() // ref() 的浅层作用形式
const imageWidth = ref()
const totalWidth = computed(() => {
  if (typeof props.width === 'number') {
    return props.width + 'px'
  } else {
    return props.width
  }
})
const height = computed(() => {
  return Math.max(...preColumnHeight.value) + props.columnGap
})
const len = computed(() => {
  return props.images.length
})
const loaded = ref(Array(len.value)) // 图片是否加载完成
const rerender = ref(false)
watch(
    () => [props.columnCount, props.columnGap, props.width],
    () => {
      rerender.value = true
      preColumnHeight.value = Array(props.columnCount).fill(0)
      onPreload()
    },
    {
      deep: true, // 强制转成深层侦听器
      flush: 'post' // 在侦听器回调中访问被 Vue 更新之后的 DOM
    }
)
watchPostEffect(() => {
  if (props.images.length) {
    onPreload()
  }
})

async function onPreload() { // 计算图片宽高和位置（top，left）
                             // 计算每列的图片宽度
                             // imageWidth.value = (waterfall.value.offsetWidth - (props.columnCount + 1) * props.columnGap) / props.columnCount
  imageWidth.value = (waterfall.value.offsetWidth - props.columnGap * (props.columnCount - 1)) / props.columnCount;
  imagesProperty.value.splice(0)
  for (let i = 0; i < len.value; i++) {
    await loadImage(props.images[i].coverUrls, i)
  }
}

function loadImage(url: string, n: number) {
  return new Promise((resolve) => {
    const image = new Image()
    image.src = url
    image.onload = function () { // 图片加载完成时执行，此时可通过image.width和image.height获取到图片原始宽高
      if (!rerender.value) {
        loaded.value[n] = false
      }
      var height = image.height / (image.width / imageWidth.value)
      imagesProperty.value[n] = { // 存储图片宽高和位置信息
        width: imageWidth.value,
        height: height > 800 ? 800 : height,
        ...getPosition(n, height)
      }
      resolve('load')
    }
  })
}

function getPosition(i: number, height: number) {
  const columnWidth = imageWidth.value;
  const leftGap = props.columnGap;

  if (i < props.columnCount) {
    preColumnHeight.value[i] = props.columnGap + height;
    return {
      top: props.columnGap,
      left: (columnWidth + leftGap) * i
    };
  } else {
    const minColHeight = Math.min(...preColumnHeight.value);
    let minColIndex = preColumnHeight.value.indexOf(minColHeight);
    preColumnHeight.value[minColIndex] += props.columnGap + height;
    return {
      top: minColHeight + props.columnGap,
      left: (columnWidth + leftGap) * minColIndex
    };
  }
}

function onLoaded(index: number) {
  loaded.value[index] = true
}

const router = useRouter()

const goDetail = (row: any) => {
  if (row.linkUrl) {
    window.open(row.linkUrl)
  } else {
    window.open("/details?id=" + row.id)
    // router.push({
    //   path: '/details',
    //   query: { id: row.id }
    // })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (__props.images && __props.images.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "m-waterfall",
        ref: (_value, _refs) => {
          _refs['waterfall'] = _value
          _isRef(waterfall) && (waterfall.value = _value)
        },
        style: _normalizeStyle(`--borderRadius: ${__props.borderRadius}px; width: ${_unref(totalWidth)}; height: ${_unref(height)}px;`)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagesProperty.value, (property, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "m-image",
            style: _normalizeStyle(`width: ${property?.width}px; height: ${property?.height}px; top: ${property && property?.top}px; left: ${property && property?.left}px;`),
            size: "small",
            indicator: "dynamic-circle",
            key: index
          }, [
            _createVNode(_component_a_spin, {
              spinning: !loaded.value[index]
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "u-image",
                  src: __props.images[index]?.coverUrls,
                  alt: __props.images[index]?.name,
                  onLoad: ($event: any) => (onLoaded(index))
                }, null, 40, _hoisted_1)
              ]),
              _: 2
            }, 1032, ["spinning"]),
            _createElementVNode("div", {
              class: "mask",
              onClick: ($event: any) => (goDetail(__props.images[index]))
            }, _hoisted_4, 8, _hoisted_2)
          ], 4))
        }), 128))
      ], 4))
    : _createCommentVNode("", true)
}
}

})